import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createCollaboratorEvent = (request) => {
    return vdkEmHappinessPortalApi.post('/collaboratorevents/create', request);
};
const updateCollaboratorEvent = (id, request) => {
    return vdkEmHappinessPortalApi.put(`/collaboratorevents/${id}`, request);
};
const getCollaboratorEventById = (id) => {
    return vdkEmHappinessPortalApi.get(`/collaboratorevents/${id}`);
};
const getAllCollaboratorEvents = () => {
    return vdkEmHappinessPortalApi.get('/collaboratorevents/get-all');
};
const deleteCollaboratorEvent = (id) => {
    return vdkEmHappinessPortalApi.delete(`/collaboratorevents/${id}`);
};
const collaboratorEventAPI = {
    createCollaboratorEvent,
    updateCollaboratorEvent,
    getCollaboratorEventById,
    getAllCollaboratorEvents,
    deleteCollaboratorEvent
};
export default collaboratorEventAPI;
